export default {
  title: 'SMS Logs',

  // Form related
  form: {
    timeRange: 'Time Range',
    sendTime: 'Send Time',
    startDate: 'Start Date',
    endDate: 'End Date',
    task: 'Task',
    taskName: 'Task Name',
    taskPlaceholder: 'Please select task',
    taskNamePlaceholder: 'Please select task name',
    taskType: 'Task Type',
    taskTypePlaceholder: 'Please select task type',
    username: 'Username',
    userName: 'Username',
    user: 'User',
    usernamePlaceholder: 'Please enter username',
    userNamePlaceholder: 'Please enter username',
    userPlaceholder: 'Please enter username',
    phone: 'Phone Number',
    phonePlaceholder: 'Please enter phone number',
    channel: 'Channel',
    channelPlaceholder: 'Please select channel',
    status: 'Status',
    statusPlaceholder: 'Please select status',
    receipt: 'Receipt Code',
    receiptPlaceholder: 'Please enter receipt code',
    updateTime: 'Update Time',
    updateTimePlaceholder: 'Please select update time'
  },

  // Table related
  table: {
    time: 'Time',
    task: 'Task',
    user: 'User',
    phone: 'Phone',
    channel: 'Channel',
    status: 'Status',
    receipt: 'Receipt'
  },

  // Status related
  status: {
    pending: 'Pending',
    success: 'Success',
    failed: 'Failed',
    unknown: 'Unknown'
  },

  // Export related
  export: {
    button: 'Export',
    loading: 'Export task created. Check progress in download list.',
    statusNotFailed: 'Only failed records can be exported. Please set status filter to "Failed" before exporting.',
    noData: 'No data to export',
    tooMany: 'Maximum 100,000 records per export. Please narrow your filters.'
  },

  // Message related
  message: {
    queryFailed: 'Query failed',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed'
  },

  // Pagination related
  pagination: {
    total: 'Total {{total}} records'
  }
};
